export const styles = {
  // textTransform:"uppercase",
  borderRadius: 0,
  boxShadow: "none",
};
